
import config from "@/config";
import http from "@/utils/request";

export default {
	gzq: {
		id: "gzq",
		url: `${config.NAIP_URL}/common/gzq`,
		name: "管制区",
		dataName: "xzqs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	jfq: {
		id: "jfq",
		name: "限制区",
		url: `${config.NAIP_URL}/common/jq`,
		dataName: "xzqs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	qbq: {
		id: "qbq",
		name: "情报区",
		url: `${config.NAIP_URL}/common/qbq`,
		dataName: "qbqVOS",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hx: {
		id: "hx",
		name: "航路-逻辑航段",
		url: `${config.NAIP_URL}/common/hx`,
		dataName: "hanglus",
		get: async function () {
			return await http.get(this.url);
		},
	},
	ndb: {
		id: "ndb",
		name: "航路点-NDB",
		url: `${config.NAIP_URL}/common/ndb`,
		dataName: "ndbvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	vor: {
		id: "vor",
		name: "航路点-VOR",
		url: `${config.NAIP_URL}/common/vor`,
		dataName: "vorvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hd: {
		id: "hd",
		name: "航路点-设计点",
		url: `${config.NAIP_URL}/common/dp`,
		dataName: "dpvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hldd: {
		id: "hldd",
		name: "航路等待",
		url: `${config.NAIP_URL}/common/rh`,
		dataName: "rhvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	mhjc: {
		id: "mhjc",
		name: "民航机场",
		url: `${config.NAIP_URL}/common/mhjc`,
		dataName: "mhjcs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	thjc: {
		id: "thjc",
		name: "通航机场",
		url: `${config.NAIP_URL}/common/thjc`,
		dataName: "thjc",
		get: async function () {
			return await http.get(this.url);
		},
	},
	jhjc: {
		id: "jhjc",
		name: "军航机场",
		url: `${config.MAIN_URL}/api/v1/jyAirports`,
		dataName: "jhjc",
		get: async function () {
			return await http.get(this.url, { pageNumber: 1, pageSize: 99999 });
		},
	},
	naipswitch: {
		name: "naip个性化",
		url: `${config.MAIN_URL}/api/v1/naip/switch`,
		dataName: "naipswitch",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	putnaipswitch: {
		url: `${config.MAIN_URL}/api/v1/naip/switch`,
		name: "naip设置监视开关状态",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},

};
